import React from "react";

export default function LoadingState({ fullScreen = false, className = "" }) {
  return (
    <div
      className={`loading-state ${fullScreen ? "loading-state--fullscreen" : ""} ${className}`.trim()}
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <div className="loading-state__ambient loading-state__ambient--sky" aria-hidden="true" />
      <div className="loading-state__ambient loading-state__ambient--ice" aria-hidden="true" />

      <div className="loading-state__skeleton" aria-hidden="true">
        <div className="loading-state__skeleton-row loading-state__skeleton-row--hero">
          <span className="loading-state__skeleton-pill loading-state__shimmer" />
          <span className="loading-state__skeleton-line loading-state__skeleton-line--lg loading-state__shimmer" />
          <span className="loading-state__skeleton-line loading-state__skeleton-line--md loading-state__shimmer" />
        </div>

        <div className="loading-state__skeleton-grid">
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="loading-state__card">
              <span className="loading-state__skeleton-pill loading-state__shimmer" />
              <span className="loading-state__skeleton-line loading-state__skeleton-line--md loading-state__shimmer" />
              <span className="loading-state__skeleton-line loading-state__skeleton-line--sm loading-state__shimmer" />
              <span className="loading-state__skeleton-line loading-state__skeleton-line--xs loading-state__shimmer" />
            </div>
          ))}
        </div>
      </div>

      <div className="loading-state__spinner-wrap" aria-hidden="true">
        <div className="loading-state__spinner">
          <span className="loading-state__spinner-ring loading-state__spinner-ring--outer" />
          <span className="loading-state__spinner-ring loading-state__spinner-ring--inner" />
          <span className="loading-state__spinner-core" />
        </div>
      </div>
    </div>
  );
}
